import Padlock from '@svg/lock.svg?react';

export const ExternalNoRolesMessage = () => {
    return (
        <div className="unauthorized-body no-roles">
            <div className="unauthorized-content">
                <div className="unauthorized-icon-background">
                    <Padlock/>
                </div>
                <div className="unauthorized-message">Unauthorized access</div>
                <div className="unauthorized-message-desc">
                    <div>You are unauthorized to access this service.</div>
                    <div>Please contact your company administrator to</div>
                    <div>request access.</div>
                </div>
            </div>
        </div>
    );
};